module.exports = __webpack_public_path__ + "static/logo-c1aec68e4a9679b7581d02d138f0970e.png";